import axios from "axios";
import { getAccessToken } from "utils";

const axiosInstance = axios.create({
  // baseURL: Backed_url,
});

axiosInstance.interceptors.request.use(async(config) => {
  config.headers.Authorization = await getAccessToken();

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
    }
    return response;
  },
  (error) => {
    const { response } = error;
    if (response?.status === 401) {
    }
    return Promise.reject(error);
  }
);



const uspcrmAxiosInstance = axios.create({
   baseURL: process.env.REACT_APP_USP_CRM,
});


uspcrmAxiosInstance.interceptors.request.use(async (config) => {
   config.headers['Content-Type'] = 'application/json';
   delete config.headers.Authorization;
   const token = await getAccessToken();
   config.headers['UspToken'] = token;
   return config;
});
export default axiosInstance;
export { uspcrmAxiosInstance };
